import { useEntities } from 'app/agriculture/queries/entities/useEntities';
import { useMemo } from 'react';

export function useDevices() {
    const devices = useEntities('Device');
    const gasbotDevices = useEntities('GasbotDevice');

    return useMemo(() => {
        const map = new Map(devices);
        for (const [id, device] of gasbotDevices) {
            map.set(id, device);
        }
        return map;
    }, [devices, gasbotDevices]);
}
